import React from "react";
import useTableCtx from "../tableContext/useTableCtx";
import SvgIcon from "../../../helpers/SvgIcon";

function TableOrder({
  label,
  value,
  withOrder,
}: {
  label?: string;
  value: string;
  withOrder?: boolean;
}) {
  const { handleTableOrder, tableOrder } = useTableCtx()!;

  const tableOrderValue = tableOrder && tableOrder[value];

  const selectedValue = tableOrderValue ?? null;

  const isOrderAscending = selectedValue === "asc";

  return (
    <div
      className={`flex w-fit items-center ${
        withOrder ? "cursor-pointer" : ""
      } `}
      onClick={() => withOrder && handleTableOrder && handleTableOrder(value)}>
      {label ?? value}
      {!!withOrder && (
        <>
          <div className="ml-2 flex flex-col">
            <SvgIcon
              type="KEYBOARD_ARROW_UP"
              fill="currentColor"
              className="-mb-2 -mt-2 h-[18px] w-[18px]"
              style={{
                height: 20,
                width: 20,
                opacity: isOrderAscending && 0.2,
              }}
            />
            <SvgIcon
              type="KEYBOARD_ARROW_DOWN"
              fill="currentColor"
              className="-mb-2 -mt-1 h-5 w-5"
              style={{
                height: 20,
                width: 20,
                opacity: !isOrderAscending && 0.2,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default TableOrder;
